import { ShimmerIconSizeTokens, } from '@voltmoney/schema';
export const shimmerIconTypeTokensMap = {
    [ShimmerIconSizeTokens.XXS]: 20,
    [ShimmerIconSizeTokens.XS]: 24,
    [ShimmerIconSizeTokens.SM]: 36,
    [ShimmerIconSizeTokens.MD]: 48,
    [ShimmerIconSizeTokens.LG]: 72,
    [ShimmerIconSizeTokens.XL]: 96,
    [ShimmerIconSizeTokens.XXL]: 128,
    [ShimmerIconSizeTokens.XXXL]: 180,
    [ShimmerIconSizeTokens.XXXXL]: 280,
    [ShimmerIconSizeTokens.XXXXXL]: 320,
    [ShimmerIconSizeTokens.FULL]: '100%',
};
